module.exports = __webpack_public_path__ + "img/dnp-2021-retrospective.f5ce27b3.png";